type RankedElement<Element> = Element & {
  rank: number;
};

export type { RankedElement };
